import { RouteConfig } from 'vue-router'

export const postureReportRoute: RouteConfig = {
  path: '/ai-test/posture-report',
  name: 'ai_test_posture_report',
  component: () => import('../../views/ai-test/posture-report/Index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体态评测',
  },
}

export const makeTestRoute: RouteConfig = {
  path: '/ai-test/make-test',
  name: 'ai_test_make_test',
  component: () => import('../../views/ai-test/make-test/index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体质测试',
  },
}

export const overviewRoute: RouteConfig = {
  path: '/ai-test/overview',
  name: 'ai_test_overview',
  component: () => import('../../views/ai-test/overview/index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体质测试报告',
  },
}

export const fitnessDetailRoute: RouteConfig = {
  path: '/ai-test/fitness-detail',
  name: 'ai_test_fitness_detail',
  component: () => import('../../views/ai-test/fitness-detail/index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体质测试详情',
  },
}

export default [postureReportRoute, makeTestRoute, overviewRoute, fitnessDetailRoute]
